var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntheirght(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 1080,
    viewBox: "0 0 671 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6498_13415)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 671,
    height: 1080,
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.617 206.138L-347.79 -149L-467 -136.593L171.626 247.234V437.985L770 797L763.807 708.603L243.617 398.439V206.138Z",
    fill: "#0D61FF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.191 108.138L-184.693 -247L-304 -234.593L335.143 149.234V339.985L934 699L927.802 610.603L407.191 300.439V108.138Z",
    fill: "#0D61FF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.617 10.1377L-20.7897 -345L-140 -332.593L498.626 51.2344V241.985L1097 601L1090.81 512.603L570.617 202.439V10.1377Z",
    fill: "#0D61FF",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6498_13415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 671,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntheirght);
export default __webpack_public_path__ + "static/media/ontheirght.e5697a57f5097ff2933cc8ac80f90b0d.svg";
export { ForwardRef as ReactComponent };